var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 14C28 21.732 21.732 28 14.0001 28C6.26807 28 0 21.732 0 14C0 6.26804 6.26796 0 13.9999 0C21.7319 0 27.9999 6.26804 27.9999 14H28ZM25.6798 13.9974C25.6798 7.54693 20.4507 2.31777 14.0002 2.31777C7.54967 2.31777 2.32055 7.54693 2.32055 13.9974C2.32055 20.4479 7.54967 25.6771 14.0002 25.6771C20.4507 25.6771 25.6798 20.4479 25.6798 13.9974Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4425 5.85934C17.7203 5.44248 20.3422 10.3606 17.5025 13.5865C16.6324 14.5749 15.3501 14.7435 15.1658 16.2852C15.0748 17.0455 15.3995 17.9463 14.6544 18.4556C13.9091 18.9652 12.928 18.4626 12.8496 17.5857C12.6957 15.8646 13.1142 14.1574 14.4681 13.0149C15.0997 12.482 15.7873 12.3075 16.1456 11.4631C17.0607 9.30667 14.717 7.26415 12.6922 8.55703C11.7553 9.15522 11.8143 9.73125 11.6432 10.6826C11.398 12.0472 9.22163 12.0838 9.34967 10.0858C9.48431 7.98536 11.3492 6.06329 13.4426 5.85934H13.4425Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.f3658d45b517be2aec97f4a31c8ecaa1.svg";
export { ForwardRef as ReactComponent };